import React, { useState } from 'react';
import './ProfileSection.css';

/// プロフィールセクション - マール・アストレアの詳細情報
const ProfileSection: React.FC = () => {
  const [showAllCards, setShowAllCards] = useState(false);

  const toggleCards = () => {
    setShowAllCards(!showAllCards);
  };

  return (
    <section className="profile-section" id="profile">
      <div className="profile-container">
        <div className="profile-header">
          <h2 className="profile-title">プロフィール</h2>
          <p className="profile-subtitle">見習い神官マール・アストレアについて</p>
        </div>

        <div className="profile-content">
          <div className="profile-card basic-info always-visible">
            <div className="card-header">
              <div className="card-icon">
                <span className="icon">👤</span>
              </div>
              <h3 className="card-title">基本情報</h3>
            </div>
            <div className="info-list">
              <div className="info-item">
                <span className="info-label">名前</span>
                <span className="info-value">マール・アストレア</span>
              </div>
              <div className="info-item">
                <span className="info-label">年齢</span>
                <span className="info-value">21歳</span>
              </div>
              <div className="info-item">
                <span className="info-label">誕生日</span>
                <span className="info-value">4月28日</span>
              </div>
              <div className="info-item">
                <span className="info-label">身長</span>
                <span className="info-value">162cm</span>
              </div>
              <div className="info-item">
                <span className="info-label">体重</span>
                <span className="info-value">44kg</span>
              </div>
              <div className="info-item">
                <span className="info-label">一人称</span>
                <span className="info-value">マール</span>
              </div>
            </div>
          </div>

          <div className={`profile-card background-story ${showAllCards ? 'mobile-visible' : 'mobile-hidden'}`}>
            <div className="card-header">
              <div className="card-icon">
                <span className="icon">🏰</span>
              </div>
              <h3 className="card-title">設定・背景</h3>
            </div>
            <div className="story-content">
              <p className="story-text">
                アストレア法国出身の見習い神官。聖王クロノス・アストレアの末裔として、
                聖法教会で神官見習いとして働いている。
              </p>
              <p className="story-text">
                15歳の誕生日に神々から「地球という惑星で信仰を広めよ」という神託を受け、
                大神官である父の助言により地球でVTuber活動を開始した。
              </p>
            </div>
          </div>

          <div className={`profile-card appearance ${showAllCards ? 'mobile-visible' : 'mobile-hidden'}`}>
            <div className="card-header">
              <div className="card-icon">
                <span className="icon">✨</span>
              </div>
              <h3 className="card-title">外見的特徴</h3>
            </div>
            <div className="appearance-grid">
              <div className="appearance-item">
                <span className="feature-icon">🤍</span>
                <div className="feature-content">
                  <h4 className="feature-title">髪色</h4>
                  <p className="feature-desc">白と薄紫の混ざったロングヘア</p>
                </div>
              </div>
              <div className="appearance-item">
                <span className="feature-icon">👀</span>
                <div className="feature-content">
                  <h4 className="feature-title">瞳</h4>
                  <p className="feature-desc">青い瞳</p>
                </div>
              </div>
              <div className="appearance-item">
                <span className="feature-icon">👑</span>
                <div className="feature-content">
                  <h4 className="feature-title">特徴</h4>
                  <p className="feature-desc">大きな帽子（でかぼうし）</p>
                </div>
              </div>
              <div className="appearance-item">
                <span className="feature-icon">💫</span>
                <div className="feature-content">
                  <h4 className="feature-title">前髪</h4>
                  <p className="feature-desc">1か所だけ飛び出した前髪</p>
                </div>
              </div>
            </div>
          </div>

          <div className={`profile-card personality ${showAllCards ? 'mobile-visible' : 'mobile-hidden'}`}>
            <div className="card-header">
              <div className="card-icon">
                <span className="icon">💖</span>
              </div>
              <h3 className="card-title">性格・特徴</h3>
            </div>
            <div className="personality-content">
              <div className="personality-traits">
                <div className="trait-item">
                  <span className="trait-label">基本性格</span>
                  <span className="trait-value">清楚で真面目、優しく純粋</span>
                </div>
                <div className="trait-item">
                  <span className="trait-label">口調</span>
                  <span className="trait-value">丁寧で上品、神官らしい話し方</span>
                </div>
                <div className="trait-item">
                  <span className="trait-label">特徴</span>
                  <span className="trait-value">天然で残念美人な一面も</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`profile-card talents ${showAllCards ? 'mobile-visible' : 'mobile-hidden'}`}>
            <div className="card-header">
              <div className="card-icon">
                <span className="icon">🎵</span>
              </div>
              <h3 className="card-title">特技・才能</h3>
            </div>
            <div className="talents-grid">
              <div className="talent-item">
                <span className="talent-icon">🎤</span>
                <div className="talent-content">
                  <h4 className="talent-title">歌唱力</h4>
                  <p className="talent-desc">
                    美しい歌声が魅力。Aimerが得意で、カラオケ最高得点98点。
                    即興アカペラも披露する高い実力。
                  </p>
                </div>
              </div>
              <div className="talent-item">
                <span className="talent-icon">📖</span>
                <div className="talent-content">
                  <h4 className="talent-title">朗読・演技</h4>
                  <p className="talent-desc">
                    ストーリーゲームでの朗読や演じ分けが得意。
                    声を生かしたエンターテイメントを提供。
                  </p>
                </div>
              </div>
              <div className="talent-item">
                <span className="talent-icon">💬</span>
                <div className="talent-content">
                  <h4 className="talent-title">雑談配信</h4>
                  <p className="talent-desc">
                    コメント読みと視聴者との交流が得意。
                    親しみやすい人柄で多くのファンを魅了。
                  </p>
                </div>
              </div>
              <div className="talent-item">
                <span className="talent-icon">⏰</span>
                <div className="talent-content">
                  <h4 className="talent-title">長時間配信</h4>
                  <p className="talent-desc">
                    マリオカート耐久配信など、長時間配信への熱意と根性。
                    最長記録は11時間28分。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={`profile-card activity-period ${showAllCards ? 'mobile-visible' : 'mobile-hidden'}`}>
            <div className="card-header">
              <div className="card-icon">
                <span className="icon">📅</span>
              </div>
              <h3 className="card-title">活動期間</h3>
            </div>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-date">2023年7月8日</div>
                <div className="timeline-event">チャンネル開設</div>
              </div>
              <div className="timeline-item">
                <div className="timeline-date">2023年10月11日</div>
                <div className="timeline-event">デビュー・初配信</div>
              </div>
              <div className="timeline-item">
                <div className="timeline-date">2024年5月31日</div>
                <div className="timeline-event">引退配信</div>
              </div>
              <div className="timeline-item">
                <div className="timeline-date">2024年6月15日</div>
                <div className="timeline-event">アーカイブ非公開化</div>
              </div>
            </div>
          </div>

          {/* スマホ表示用のトグルボタン */}
          <div className="mobile-toggle-container">
            <button 
              className="mobile-toggle-button"
              onClick={toggleCards}
            >
              <span className="button-icon">
                {showAllCards ? '📖' : '📋'}
              </span>
              <span className="button-text">
                {showAllCards ? 'プロフィールを閉じる' : 'その他のプロフィール'}
              </span>
              <span className="button-arrow">
                {showAllCards ? '▲' : '▼'}
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileSection; 